import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import React, {FC, useCallback, useContext} from 'react';
import style from './style.module.scss';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import classNames from 'classnames';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';

export const ShowFiltersButtonMobile: FC = () => {
    const dispatch = useAppDispatch();
    const {appliedFilters} = useContext(FilterContext);
    const {wineShop} = useContext(FilterPickupTodayButtonContext);

    const handleClick = useCallback(() => {
        dispatch(showModal(MODALS.FILTER_MODAL_MOBILE.name));
    }, [dispatch]);

    const count = appliedFilters.length + (wineShop ? 1 : 0);

    return (
        <button
            className={classNames(style.main, 0 < count ? style.showCounter : '')}
            onClick={handleClick}
            type={'button'}
        >
            <Icon className={style.icon} icon={'filter-new'} />
            <Typography variant={'label-12-m'}>Фильтры</Typography>
            <span className={style.counter}>
                <Typography variant={'label-10-b'}>{count}</Typography>
            </span>
        </button>
    );
};
